import React from "react";
import grl from "../../assets/grl.jpg";
import { Box, Typography } from "@mui/material";
import { domain } from "../../constants/generalConstant";
import One from "./One";
import Two from "./Two";
import Three from "./Three";

export default function LandingPage() {
	return (
		<section className="">
			<a
				className="fixed   top-[75%]  md:top-[81%]      right-[10%]  md:right-[2rem] z-50"
				href="https://wa.me/+447438898686"
				target="_blank"
				rel="noopener noreferrer">
				<img
					src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
					alt="WhatsApp"
					width="50"
					height="50"
				/>
			</a>
			<One />
			<Two />
			<Three />
		</section>
	);
}
// This is a simple landing page component for a React application.
